// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__eXLEQ","rightAdornment":"Header_rightAdornment__SpJ9Y"};